import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, ShieldAlert, Bell, FileText, Activity, Database } from 'lucide-react';

const TenantHeader = ({ tenantId, tenantName, subtitle, children }) => {
  const location = useLocation();

  const tabs = [
    { label: 'Overview', path: `/msp/tenants/${tenantId}`, icon: LayoutDashboard },
    { label: 'Findings', path: `/msp/tenants/${tenantId}/findings`, icon: ShieldAlert },
    { label: 'Alerts', path: `/msp/tenants/${tenantId}/alerts`, icon: Bell },
    { label: 'Assets', path: `/msp/tenants/${tenantId}/assets`, icon: Database },
    { label: 'Reports', path: `/msp/tenants/${tenantId}/reports`, icon: FileText },
    { label: 'History', path: `/msp/tenants/${tenantId}/external-scans`, icon: Activity },
  ];

  return (
    <div className="tenant-header-container">
      <div className="msp-header" style={{ borderBottom: 'none', paddingBottom: '8px' }}>
        <div>
          <h1>{tenantName}</h1>
          {subtitle && <p className="msp-subtitle">{subtitle}</p>}
        </div>
        <div className="msp-header-actions">
          {children}
        </div>
      </div>
      <nav className="msp-tabs">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          // Exact match for Overview, startsWith for others to handle sub-routes if any
          const isActive = tab.label === 'Overview' 
            ? location.pathname === tab.path 
            : location.pathname.startsWith(tab.path);
          
          return (
            <Link
              key={tab.label}
              to={tab.path}
              className={`msp-tab-item ${isActive ? 'active' : ''}`}
            >
              <Icon size={16} />
              <span>{tab.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default TenantHeader;
